import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import BottomSheet from 'components/BottomSheet';
import FlightsSearch from 'components/FlightsSearch';
import { Desktop, Mobile } from 'components/Responsive';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { TravelArrangerUsersAllowed } from 'services/userService';

import { Container } from './styles';

type Props = {
  allowedTravelers: TravelArrangerUsersAllowed[];
  isLoadingAllowedTravelers: boolean;
  show: boolean;
  onClose: () => void;
  branchCompanies?: GetAllBillingCompanyResponse[];
  isLoadingBranchCompanies: boolean;
};

const FlightsSearchEdit = ({
  allowedTravelers,
  isLoadingAllowedTravelers,
  show,
  onClose,
  branchCompanies,
  isLoadingBranchCompanies,
}: Props) => {
  const {
    travelers,
    departurePoint,
    arrivalPoint,
    departureDate,
    returnDate,
    baggageIncluded,
    directFlight,
    cabin,
    departureTime,
    returnTime,
    branchCompany,
    multiDestinationTrips,
    flightStretch,
  } = useSelector((state: RootState) => state.flights);

  const search = () => (
    <FlightsSearch
      defaultTravelers={travelers}
      defaultDeparturePoint={departurePoint}
      defaultArrivalPoint={arrivalPoint}
      defaultDepartureDate={departureDate}
      defaultReturnDate={returnDate}
      defaultDepartureTime={departureTime}
      defaultReturnTime={returnTime}
      defaultBaggageIncluded={baggageIncluded}
      defaultDirectFlight={directFlight}
      defaultCabin={cabin}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      isHome={false}
      onClose={onClose}
      branchCompanies={branchCompanies}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      defaultBranchCompany={branchCompany}
      defaultFlightStretch={flightStretch}
      defaultMultiDestinationTrips={multiDestinationTrips}
    />
  );

  return (
    <>
      <Mobile>
        <BottomSheet show={show} onClose={onClose} noHeader zIndex={2}>
          {search()}
        </BottomSheet>
      </Mobile>
      <Desktop>
        <ApplicationOverlayContent show={show} onClose={onClose}>
          <Container>{search()}</Container>
        </ApplicationOverlayContent>
      </Desktop>
    </>
  );
};
export default FlightsSearchEdit;
